/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
    type V1ErrorResponse,
    V1ErrorResponseFromJSON,
    V1ErrorResponseToJSON
} from '../models/V1ErrorResponse'
import {
    type V1LinkTarget,
    V1LinkTargetFromJSON,
    V1LinkTargetToJSON
} from '../models/V1LinkTarget'
import {
    type V1ReferralCode,
    V1ReferralCodeFromJSON,
    V1ReferralCodeToJSON
} from '../models/V1ReferralCode'
import {
    type V1ReferralCodeInfo,
    V1ReferralCodeInfoFromJSON,
    V1ReferralCodeInfoToJSON
} from '../models/V1ReferralCodeInfo'
import {
    type V1ReferralStatus,
    V1ReferralStatusFromJSON,
    V1ReferralStatusToJSON
} from '../models/V1ReferralStatus'

export interface EnsureReferralCodeRequest {
    /**
     *
     */
    programId: string
}

export interface ResolveLinkRequest {
    /**
     *
     */
    slug: string
}

export interface ResolveReferralCodeRequest {
    /**
     *
     */
    code: string
}

/**
 *
 */
export class ReferralsApi extends runtime.BaseAPI {
    /**
     * Creates request options for ensureReferralCode without sending the request
     */
    async ensureReferralCodeRequestOpts(
        requestParameters: EnsureReferralCodeRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['programId'] == null) {
            throw new runtime.RequiredError(
                'programId',
                'Required parameter "programId" was null or undefined when calling ensureReferralCode().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/referrals/{programId}/code`
        urlPath = urlPath.replace(
            '{programId}',
            encodeURIComponent(String(requestParameters['programId']))
        )

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Idempotent: returns the existing code when there is one.
     * Get or create the caller\'s referral code in a program
     */
    async ensureReferralCodeRaw(
        requestParameters: EnsureReferralCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1ReferralCode>> {
        const requestOptions =
            await this.ensureReferralCodeRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1ReferralCodeFromJSON(jsonValue)
        )
    }

    /**
     * Idempotent: returns the existing code when there is one.
     * Get or create the caller\'s referral code in a program
     */
    async ensureReferralCode(
        requestParameters: EnsureReferralCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1ReferralCode> {
        const response = await this.ensureReferralCodeRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for getReferrals without sending the request
     */
    async getReferralsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/referrals`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Every running program the caller may recommend in, with their code (once taken), how their referrals went and the rewards they earned.
     * The caller\'s referral programs
     */
    async getReferralsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1ReferralStatus>> {
        const requestOptions = await this.getReferralsRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1ReferralStatusFromJSON(jsonValue)
        )
    }

    /**
     * Every running program the caller may recommend in, with their code (once taken), how their referrals went and the rewards they earned.
     * The caller\'s referral programs
     */
    async getReferrals(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1ReferralStatus> {
        const response = await this.getReferralsRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for resolveLink without sending the request
     */
    async resolveLinkRequestOpts(
        requestParameters: ResolveLinkRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling resolveLink().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/links/{slug}`
        urlPath = urlPath.replace(
            '{slug}',
            encodeURIComponent(String(requestParameters['slug']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * The app navigates to the returned path.
     * Where a tracked link (startapp=l_<slug>) opens
     */
    async resolveLinkRaw(
        requestParameters: ResolveLinkRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1LinkTarget>> {
        const requestOptions =
            await this.resolveLinkRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1LinkTargetFromJSON(jsonValue)
        )
    }

    /**
     * The app navigates to the returned path.
     * Where a tracked link (startapp=l_<slug>) opens
     */
    async resolveLink(
        requestParameters: ResolveLinkRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1LinkTarget> {
        const response = await this.resolveLinkRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for resolveReferralCode without sending the request
     */
    async resolveReferralCodeRequestOpts(
        requestParameters: ResolveReferralCodeRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling resolveReferralCode().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/referrals/codes/{code}`
        urlPath = urlPath.replace(
            '{code}',
            encodeURIComponent(String(requestParameters['code']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * For the invited user\'s invited-by note and landing page.
     * Who a referral code belongs to
     */
    async resolveReferralCodeRaw(
        requestParameters: ResolveReferralCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1ReferralCodeInfo>> {
        const requestOptions =
            await this.resolveReferralCodeRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1ReferralCodeInfoFromJSON(jsonValue)
        )
    }

    /**
     * For the invited user\'s invited-by note and landing page.
     * Who a referral code belongs to
     */
    async resolveReferralCode(
        requestParameters: ResolveReferralCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1ReferralCodeInfo> {
        const response = await this.resolveReferralCodeRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }
}
